<script setup>
import KitError from "@/components/approval-center/partials/kit/KitError.vue";
import KitWink from "@/components/approval-center/partials/kit/KitWink.vue";
import KitDefault from "@/components/approval-center/partials/kit/KitDefault.vue";
import KitSuccess from "@/components/approval-center/partials/kit/KitSuccess.vue";
import KitThinking from "@/components/approval-center/partials/kit/KitThinking.vue";
import {seoAgentIcon} from "@/composables/useLocalDomains";
import {hasCustomDomainSetup} from "@/composables/useLocalDomains";
import KitSad from "@/components/approval-center/partials/kit/KitSad.vue";

defineProps({
  state: {
    type: String,
    default: 'default',
    validator: (value) => [
      'default',
      'success',
      'error',
      'thinking',
      'wink',
      'sad',
    ].includes(value)
  },
});

const iconMap = {
  default: KitDefault,
  success: KitSuccess,
  error: KitError,
  thinking: KitThinking,
  wink: KitWink,
  sad: KitSad,
};
</script>

<template>
  <img
    v-if="seoAgentIcon"
    :src="seoAgentIcon"
    class="tw-shrink-0 tw-w-16 tw-h-auto"
  >

  <component
    :is="iconMap[state]"
    v-else-if="!hasCustomDomainSetup"
    class="tw-shrink-0 tw-w-16 tw-h-auto"
  />
</template>
